import React from 'react'

import StarRating from 'tailwind/common/components/StarRating'
import sentImage from 'icons/sent.png'
import lightingImage from 'icons/lighting.png'

const BusinessSidebarCompact = ({
  businessName,
  suburbName,
  rating,
  reviews,
  hasFeedbackScore,
  hasLogo,
  logoUrl,
  logoInitials,
  logoColor,
  displayPhone,
  bookingPath,
  canCall,
  canBook,
  userName,
  respondsLabel,
}) => (
  <div className="relative w-full p-2 bg-base-blue-main rounded-10 flex flex-col items-center gap-2 overflow-hidden">
    <div className="pointer-events-none absolute inset-x-0 bottom-0 h-64" aria-hidden="true">
      <div className="w-[181px] h-[196px] absolute opacity-60 bg-base-blue-950 blur-[75px] right-0 bottom-0" />
      <div className="w-[258px] h-[275px] absolute opacity-75 bg-base-green-200 blur-[75px] left-[-30px] bottom-0" />
    </div>

    <div className="relative self-stretch px-3 py-4 rounded-10 flex justify-center items-center">
      <div className="absolute inset-0 bg-white/20 rounded-10" />

      <div className="relative flex items-center gap-4 min-w-0 max-w-full">
        <div className="relative shrink-0 w-12 h-12 rounded-full shadow-md aspect-square">
          {hasLogo ? (
            <img
              src={logoUrl}
              alt="Business logo"
              className="w-12 h-12 rounded-full object-cover aspect-square"
            />
          ) : (
            <span
              className="flex w-12 h-12 items-center justify-center text-sm font-semibold text-white rounded-full aspect-square"
              style={{ backgroundColor: logoColor || '#000' }}
            >
              {logoInitials}
            </span>
          )}
          <div className="absolute w-6 h-6 -right-1 bottom-[-2px] bg-surface rounded-full flex items-center justify-center border border-base-border aspect-square shadow-md">
            <img src={sentImage} alt="" className="w-3.5 h-3.5" aria-hidden="true" />
          </div>
        </div>

        <div className="relative flex flex-col items-start gap-0.5 min-w-0">
          <div className="flex items-center gap-0.5">
            <span className="text-surface text-base font-extrabold truncate">{userName}</span>
            <hero-icon-solid name="check-circle" class="w-2.5 h-2.5 text-base-green-main"></hero-icon-solid>
          </div>
          <span className="text-surface text-lg font-extrabold drop-shadow-sm leading-tight">
            {businessName}
          </span>
          <span className="text-surface text-sm font-medium truncate">{suburbName}</span>
          {hasFeedbackScore && (
            <div className="flex flex-wrap items-center gap-0.5">
              <span className="text-surface text-sm font-extrabold">{rating}</span>
              <StarRating fontOptions="text-sm" rating={rating} starsOnly={true} />
              <span className="text-surface text-sm font-medium">
                {reviews} {reviews === 1 ? 'Review' : 'Reviews'}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>

    <div className="relative self-stretch pt-2 flex flex-col items-center gap-2">
      <div className="flex flex-col items-center gap-1">
        <div className="flex items-center gap-2">
          <img src={lightingImage} alt="" className="w-4 h-4" aria-hidden="true" />
          <span className="text-surface text-sm font-normal">{respondsLabel}</span>
        </div>
        {displayPhone && (
          <p className="text-surface text-lg font-extrabold">{displayPhone}</p>
        )}
      </div>

      {(canCall || canBook) && (
        <div className="w-full flex gap-2">
          {canCall && displayPhone && (
            <a
              href={`tel:${displayPhone}`}
              className="flex-1 h-8 min-h-8 px-2 bg-base-gray-50 rounded-5 flex justify-center items-center text-base-gray-text-main text-xs font-medium"
            >
              Call
            </a>
          )}
          {canBook && (
            <a
              href={bookingPath}
              className="flex-1 h-8 min-h-8 px-2 bg-base-green-main rounded-5 flex justify-center items-center text-surface text-xs font-medium"
            >
              Book
            </a>
          )}
        </div>
      )}
    </div>
  </div>
)

export default BusinessSidebarCompact
